import { MatDialogConfig } from '@angular/material/dialog';

export const DefaultDialogConfig: MatDialogConfig<any> = {
  disableClose: true,
  restoreFocus: false,
  closeOnNavigation: true,
};

export const Constants = {
  DefaultValues: {
    colorReset: {
      id: null,
      hexCode: '#FFFFFF',
    },
    unassignedGroupId: -1,
    allValues: 'ALL',
    dateDisplayFormat: 'dd-MM-yy',
    dateDisplayFormatWithTime: 'dd-MM-yy HH:mm',
    timeDisplayFormat: 'HH:mm:ss',
    decimalDisplayFormat: '1.2-2',
  },
  NumericOptions: {
    minPercentage: 0,
    maxPercentage: 100,
  },
};
